import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { MENUITEMS, type Menuitemtype } from '../sidebar/nav';
import { Button, Dropdown, DropdownDivider, InputGroup, ListGroup, Modal, Spinner } from 'react-bootstrap'
import { getCaresShellBootstrap } from '../../../components/cares/shell/bootstrap';
import { useShellBranding } from '../../../components/cares/shell/branding';
import {
  fetchNotificationPreview,
  type NotificationItem,
  subscribeToNotificationsUpdated,
  updateNotificationReadState,
} from '../../../components/cares/notifications/api';
import {
  getMobileSidebarPinned,
  getState,
  setMobileSidebarPinned,
  setState,
} from '../../services/switcherServices';


interface HeaderProps { }

const getNotificationErrorMessage = (error: unknown, fallback: string) =>
  error instanceof Error && error.message ? error.message : fallback;

const Header: React.FC<HeaderProps> = () => {
  const caresBootstrap = getCaresShellBootstrap();
  const branding = useShellBranding();

  //Search function in small screen

  let [variable, _setVariable] = useState(getState());

  const [headerstate, setHeaderState] = useState({
    show: false,
    searchInput: '',
    showListGroup: false,
    isFullScreen: false,
  });
  const [notifications, setNotifications] = useState<NotificationItem[]>([]);
  const [notificationsLoading, setNotificationsLoading] = useState(true);
  const [notificationsRefreshing, setNotificationsRefreshing] = useState(false);
  const [notificationUnreadCount, setNotificationUnreadCount] = useState<number | null>(null);
  const [notificationLoadError, setNotificationLoadError] = useState<string | null>(null);
  const [notificationRefreshWarning, setNotificationRefreshWarning] = useState<string | null>(null);
  const [notificationActionError, setNotificationActionError] = useState<string | null>(null);
  const [markingNotificationId, setMarkingNotificationId] = useState<string | null>(null);
  const hasLoadedNotificationPreviewRef = useRef(false);


  const handleClose = () => setHeaderState(prev => ({ ...prev, show: false }));
  const handleShow = () => setHeaderState(prev => ({ ...prev, show: true }));

  // MenuClose Function

  function menuClose() {
    const theme = getState();

    if (window.innerWidth <= 992) {
      const newState = {
        toggled: "close"
      }
      setState(newState);
    }

    if (window.innerWidth >= 992) {
      const local_varaiable = theme;
      const newToggledValue = local_varaiable.toggled ? local_varaiable.toggled : '';

      setState({ toggled: newToggledValue });
    }
  }

  // Sidebar Toggle Function

  const overlayRef = useRef<HTMLDivElement | null>(null);
  const Query = (selector: string): Element | null => document.querySelector(selector);

  const toggleSidebar = () => {
    const theme = getState();
    const sidemenuType = theme.dataNavLayout;
    if (window.innerWidth >= 992) {
      if (sidemenuType === "vertical") {
        const verticalStyle = theme.dataVerticalStyle;
        const navStyle = theme.dataNavStyle;
        switch (verticalStyle) {
          case "closed":
            // Toggle between open/close state for "closed" vertical style
            setState({
              dataNavStyle: "",
              toggled: theme.toggled === "close-menu-close" ? "" : "close-menu-close"
            });
            break;
          case "overlay":
            // Handle icon-overlay state with window width check
            setState({
              dataNavStyle: "",
              toggled: theme.toggled === "icon-overlay-close" ? "" : "icon-overlay-close",
              iconOverlay: ""
            });

            if (theme.toggled !== "icon-overlay-close" && window.innerWidth >= 992) {
              setState({
                toggled: "icon-overlay-close",
                iconOverlay: "",
              });
            }
            break;
          case "icontext":
            // Handle icon-text state
            setState({
              dataNavStyle: "",
              toggled: theme.toggled === "icon-text-close" ? "" : "icon-text-close"
            });
            break;
          case "doublemenu":
            // Handle double menu state
            setState({ dataNavStyle: "" });
            if (theme.toggled === "double-menu-open") {
              setState({ toggled: "double-menu-close" });
            } else {
              // Toggle the active double menu item
              const sidemenu = Query(".side-menu__item.active");
              if (sidemenu) {
                setState({ toggled: "double-menu-open" });
                if (sidemenu.nextElementSibling) {
                  sidemenu.nextElementSibling.classList.add("double-menu-active");
                } else {
                  setState({ toggled: "double-menu-close" });
                }
              }
            }
            break;
          case "detached":
            // Handle detached menu state
            setState({
              toggled: theme.toggled === "detached-close" ? "" : "detached-close",
              iconOverlay: ""
            });
            break;
          default:
            setState({ toggled: "" });
            break;
        }

        // Handle navStyle changes
        switch (navStyle) {
          case "menu-click":
            setState({
              toggled: theme.toggled === "menu-click-closed" ? "" : "menu-click-closed"
            });
            break;
          case "menu-hover":
            setState({
              toggled: theme.toggled === "menu-hover-closed" ? "" : "menu-hover-closed"
            });
            break;
          case "icon-click":
            setState({
              toggled: theme.toggled === "icon-click-closed" ? "" : "icon-click-closed"
            });
            break;
          case "icon-hover":
            setState({
              toggled: theme.toggled === "icon-hover-closed" ? "" : "icon-hover-closed"
            });
            break;
        }
      }
    } else {
      // For mobile view (screen width < 992px)
      if (theme.toggled === "close") {
        setState({ toggled: "open" });

        setTimeout(() => {
          if (!getMobileSidebarPinned()) {
            const overlay = overlayRef.current
            if (overlay) {
              overlay.classList.add("active");
              overlay.addEventListener("click", () => {
                const overlay = overlayRef.current
                if (overlay) {
                  overlay.classList.remove("active");
                  menuClose();
                }
              });
            }
          }
          window.addEventListener("resize", () => {
            if (window.innerWidth >= 992) {
              const overlay = Query("#responsive-overlay");
              if (overlay) {
                overlay.classList.remove("active");
              }
            }
          });
        }, 100);
      } else {
        if (getMobileSidebarPinned()) {
          setMobileSidebarPinned(false);
        }
        setState({ toggled: "close" });
      }
    }
  };

  //Search function




  const menuItems: Menuitemtype[] = MENUITEMS;

  const filterMenuItems = (items: Menuitemtype[]): Menuitemtype[] => {
    return items.reduce((filteredItems: Menuitemtype[], item: Menuitemtype) => {
      if (item.menusub) {
        const filteredChildren = filterMenuItems(item.children || []);
        if (filteredChildren.length > 0) {
          filteredItems.push({ ...item, children: filteredChildren });
        }
      } else if (
        item.title &&
        (item.title.toLowerCase().includes(headerstate.searchInput.toLowerCase()) ||
          headerstate.searchInput.toLowerCase().includes(item.title.toLowerCase()))
      ) {
        filteredItems.push(item);
      }

      return filteredItems;
    }, []);
  };

  const listGroupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (listGroupRef.current && !listGroupRef.current.contains(event.target as Node)) {
        setHeaderState(prev => ({ ...prev, showListGroup: false }));
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [listGroupRef]);

  const flattenMenuItems = (items: Menuitemtype[]): Menuitemtype[] => {
    return items.reduce((flattenedItems: Menuitemtype[], item: Menuitemtype) => {
      flattenedItems.push(item);

      if (item.children) {
        flattenedItems = flattenedItems.concat(flattenMenuItems(item.children));
      }

      return flattenedItems;
    }, []);
  };

  const filteredMenuItems = filterMenuItems(menuItems);
  const flattenedFilteredMenuItems = flattenMenuItems(filteredMenuItems);

  const handleListItemClick = () => {
    setHeaderState(prev => ({ ...prev, showListGroup: false }));
  };




  //Dark Model
  const toggleTheme = () => {
    const currentTheme = getState();
    const newState = {
      dataThemeMode: currentTheme.dataThemeMode === 'dark' ? 'light' : 'dark',
      dataHeaderStyles: currentTheme.dataThemeMode === 'dark' ? 'light' : 'dark',
      dataMenuStyles: currentTheme.dataThemeMode === 'dark' ? 'light' : 'dark',
    }
    setState(newState)
    localStorage.setItem("caresThemeMode", newState.dataThemeMode);
    if (newState.dataThemeMode != 'dark') {
      const newState = {
        bodyBg: '',
        lightRgb: '',
        bodyBg2: '',
        inputBorder: '',
        formControlBg: '',
        gray: '',
      }
      setState(newState)
      localStorage.setItem("udonlightTheme", "light");
      localStorage.removeItem("udondarkTheme");
      localStorage.removeItem("udonmenu");
      localStorage.removeItem("udonheader");
      localStorage.removeItem("bodyBg");
      localStorage.removeItem("bodyBg2");
      localStorage.removeItem("bgImg");
    }
    else {
      localStorage.setItem("udondarkTheme", "dark");
      localStorage.removeItem("udonlightTheme");
      localStorage.removeItem("udonmenu");
      localStorage.removeItem("udonheader");
      localStorage.removeItem("bodyBg");
      localStorage.removeItem("bodyBg2");
      localStorage.removeItem("inputBorder");
      localStorage.removeItem("lightRgb");
      localStorage.removeItem("formControlBg");
      localStorage.removeItem("gray");
    }
  }


  const loadNotificationPreview = async (options: { preserveExistingOnError?: boolean } = {}) => {
    const { preserveExistingOnError = false } = options;
    const hasReliablePreview = hasLoadedNotificationPreviewRef.current;

    if (preserveExistingOnError && hasReliablePreview) {
      setNotificationsRefreshing(true);
    } else {
      setNotificationsLoading(true);
    }

    setNotificationLoadError(null);
    setNotificationRefreshWarning(null);

    try {
      const payload = await fetchNotificationPreview();
      setNotifications(payload.items);
      setNotificationUnreadCount(payload.count);
      setNotificationActionError(null);
      hasLoadedNotificationPreviewRef.current = true;
    } catch (requestError) {
      if (preserveExistingOnError && hasReliablePreview) {
        setNotificationRefreshWarning('Notifications could not be refreshed. Showing the latest available preview.');
      } else {
        setNotifications([]);
        setNotificationUnreadCount(null);
        setNotificationLoadError(
          getNotificationErrorMessage(requestError, 'Unable to load notifications right now.')
        );
      }
    } finally {
      setNotificationsLoading(false);
      setNotificationsRefreshing(false);
    }
  };

  useEffect(() => {
    void loadNotificationPreview();

    return subscribeToNotificationsUpdated(() => {
      void loadNotificationPreview({ preserveExistingOnError: true });
    });
  }, []);

  const markNotificationRead = async (id: string) => {
    setMarkingNotificationId(id);
    setNotificationActionError(null);

    try {
      const updatedNotification = await updateNotificationReadState(id, true);
      const currentNotification = notifications.find((notification) => notification.id === id);

      setNotifications((current) =>
        current.map((notification) => (
          notification.id === id ? updatedNotification : notification
        ))
      );

      if (currentNotification && !currentNotification.is_read && updatedNotification.is_read) {
        setNotificationUnreadCount((current) => (
          current === null ? null : Math.max(0, current - 1)
        ));
      }
    } catch (requestError) {
      setNotificationActionError(
        getNotificationErrorMessage(requestError, 'Unable to mark this notification as read right now.')
      );
    } finally {
      setMarkingNotificationId(null);
    }
  };

  //full screen function

  const [isFullScreen, setIsFullScreen] = useState(false);

  const elem = document.documentElement as (HTMLElement & {
    requestFullscreen?: () => Promise<void>;
    webkitRequestFullscreen?: () => Promise<void>;
    msRequestFullscreen?: () => Promise<void>;
  });

  const openFullscreen = () => {
    if (
      !document.fullscreenElement &&
      !document.fullscreenElement &&
      !(document as any).msFullscreenElement
    ) {
      requestFullscreen();
    } else {
      exitFullscreen();
    }
  };

  const requestFullscreen = () => {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if ((elem as any).msRequestFullscreen) {
      (elem as any).msRequestFullscreen();
    }
    setIsFullScreen(true);
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
    setIsFullScreen(false);
  };

  const handleFullscreenChange = () => {
    if (document.fullscreenElement || document.fullscreenElement || (document as any).msFullscreenElement) {
      setIsFullScreen(true);
    } else {
      setIsFullScreen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  //Switcher functionality



  return (
    <Fragment>
      <header className="app-header">
        <div className="main-header-container container-fluid">
          {variable.toggled === "open" && (
            <div ref={overlayRef} id="responsive-overlay"></div>
          )}
          <div className="d-flex">
            <div className="header-content-left">
              <div className="header-element">
                <div className="horizontal-logo">
                  <Link to={`/my-schedule`} className="header-logo">
                    <img src={branding.desktopLogo} alt={branding.alt} className="desktop-logo" />
                    <img src={branding.toggleLogo} alt={branding.alt} className="toggle-logo" />
                    <img src={branding.desktopDark} alt={branding.alt} className="desktop-dark" />
                    <img src={branding.toggleDark} alt={branding.alt} className="toggle-dark" />
                  </Link>
                </div>
              </div>
              <div className="header-element mx-lg-0 mx-2" onClick={() => toggleSidebar()}>
                <Link aria-label="Hide Sidebar" className="sidemenu-toggle header-link animated-arrow hor-toggle horizontal-navtoggle" to="#"><span></span></Link>
              </div>
            </div>
            <div className="header-content-left">
              <div className="header-element header-search d-md-block d-none">
                <input type="text" className="header-search-bar form-control border-0 bg-body" placeholder="Search for Results..." value={headerstate.searchInput} onChange={(e) => setHeaderState(prev => ({ ...prev, searchInput: e.target.value, showListGroup: !!e.target.value }))} />
                <Link to="#" className="header-search-icon border-0"><i className="bi bi-search"></i></Link>
                {headerstate.showListGroup && (
                  <div ref={listGroupRef}>
                    {flattenedFilteredMenuItems.length > 0 ? (
                      <ListGroup className='search_drop'>
                        {flattenedFilteredMenuItems.map((item, index) => (
                          <ListGroup.Item key={index} onClick={handleListItemClick}>
                            <Link to={item.path ?? `/my-schedule`}>{item.title}</Link>
                          </ListGroup.Item>
                        ))}
                      </ListGroup>
                    ) : (
                      <p className='not_found'>No results</p>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <ul className="header-content-right">
            <li className="header-element d-md-none d-block">
              <Link to="#" className="header-link" onClick={handleShow}><i className="bi bi-search header-link-icon"></i></Link>
              <Modal show={headerstate.show} onHide={handleClose}>
                <Modal.Body>
                  <InputGroup>
                    <input
                      placeholder="Search Anything ..."
                      className="border-end-0 form-control"
                      aria-label="Search Anything ..."
                      aria-describedby="button-addon2"
                      value={headerstate.searchInput}
                      onChange={(e) =>
                        setHeaderState((prev) => ({
                          ...prev,
                          searchInput: e.target.value,
                          showListGroup: !!e.target.value,
                        }))
                      }
                    />
                    <InputGroup.Text id="button-addon2" className="btn btn-primary"><i className="bi bi-search"></i></InputGroup.Text>
                  </InputGroup>
                  {headerstate.showListGroup && (
                    <div ref={listGroupRef}>
                      {flattenedFilteredMenuItems.length > 0 ? (
                        <ListGroup className='search_drop'>
                          {flattenedFilteredMenuItems.map((item, index) => (
                            <ListGroup.Item key={index} onClick={(_event) => { handleListItemClick(); handleClose(); }}>
                              <Link to={item.path ?? `/my-schedule`}>{item.title}</Link>
                            </ListGroup.Item>
                          ))}
                        </ListGroup>
                      ) : (
                        <p className='not_found_smallscreen'>No results found</p>
                      )}
                    </div>
                  )}
                </Modal.Body>
              </Modal>

            </li>
            <li className="header-element header-theme-mode">

              <Link to="#" className="header-link layout-setting" onClick={() => toggleTheme()}>
                <span className="light-layout">
                  <i className="bi bi-moon header-link-icon"></i>
                </span>
                <span className="dark-layout">
                  <i className="bi bi-brightness-high header-link-icon"></i>
                </span>
              </Link>

            </li>
            {/* Notification dropdown */}
            <Dropdown className="header-element notifications-dropdown d-xl-block d-none" autoClose="outside">
              <Dropdown.Toggle className="header-link" variant="" as='a' id="dropdown-basic">
                <i className="bi bi-bell header-link-icon"></i>
                {notificationUnreadCount !== null && notificationUnreadCount > 0 ? (
                  <>
                    <span className="badge bg-secondary rounded-pill header-icon-badge">{notificationUnreadCount}</span>
                    <span className="header-icon-pulse bg-secondary rounded pulse pulse-secondary"></span>
                  </>
                ) : null}
                {notificationLoadError ? (
                  <span className="badge bg-warning rounded-pill header-icon-badge">!</span>
                ) : null}
              </Dropdown.Toggle>

              <Dropdown.Menu className="main-header-dropdown" align='start'>
                <div className="p-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="mb-0 fs-16">Notifications</p>
                    <span className="badge bg-secondary-transparent" id="notifiation-data">
                      {notificationLoadError ? 'Unavailable' : `${notificationUnreadCount ?? 0} Unread`}
                    </span>
                  </div>
                </div>
                <DropdownDivider />
                <div className="list-unstyled mb-0">
                  {notificationsLoading ? (
                    <div className="p-4 text-center text-muted">
                      <Spinner animation="border" size="sm" className="me-2" />
                      Loading notifications...
                    </div>
                  ) : null}

                  {!notificationsLoading && notificationLoadError ? (
                    <div className="p-4 text-center">
                      <span className="avatar avatar-lg avatar-rounded bg-warning-transparent text-warning">
                        <i className="ti ti-alert-triangle fs-20"></i>
                      </span>
                      <h6 className="fw-medium mt-3 mb-2">Notifications unavailable</h6>
                      <p className="text-muted fs-12 mb-3">{notificationLoadError}</p>
                      <Button
                        size="sm"
                        variant="secondary"
                        onClick={() => {
                          void loadNotificationPreview();
                        }}
                      >
                        Retry
                      </Button>
                    </div>
                  ) : null}

                  {!notificationsLoading && !notificationLoadError && notificationRefreshWarning ? (
                    <div className="px-3 pt-3">
                      <div className="alert alert-warning py-2 px-3 mb-3">
                        <div className="d-flex align-items-start justify-content-between gap-2">
                          <span className="fs-12">{notificationRefreshWarning}</span>
                          <Button
                            size="sm"
                            variant="warning"
                            className="py-0 px-2"
                            onClick={() => {
                              void loadNotificationPreview({ preserveExistingOnError: true });
                            }}
                            disabled={notificationsRefreshing}
                          >
                            {notificationsRefreshing ? 'Retrying...' : 'Retry'}
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  {!notificationsLoading && !notificationLoadError && notificationActionError ? (
                    <div className="px-3">
                      <div className="alert alert-danger py-2 px-3 mb-3">
                        <span className="fs-12">{notificationActionError}</span>
                      </div>
                    </div>
                  ) : null}

                  {!notificationsLoading && !notificationLoadError && notifications.length === 0 && (
                    <div className="p-5 empty-item1">
                      <div className="text-center">
                        <span className="avatar avatar-xl avatar-rounded bg-secondary-transparent">
                          <i className="ri-notification-off-line fs-2"></i>
                        </span>
                        <h6 className="fw-medium mt-3">No New Notifications</h6>
                      </div>
                    </div>
                  )}

                  {notifications.map((notify) => (
                    <Fragment key={notify.id}>
                      <div className='dropdown-item'>
                        <div className="d-flex align-items-center">
                          <div className="pe-2 lh-1">
                            <span className={`avatar avatar-rounded ${notify.is_read ? 'bg-light text-default' : 'bg-secondary-transparent text-secondary'}`}>
                              <i className={`ti ${notify.is_read ? 'ti-mail-opened' : 'ti-bell-ringing'} fs-18`}></i>
                            </span>
                          </div>
                          <div className="flex-grow-1 d-flex align-items-center justify-content-between">
                            <div>
                              <p className="mb-0 fw-medium">
                                <Link to={notify.target ?? '/pages/notification'}>{notify.title}</Link>
                              </p>
                              <span className="text-muted fw-normal fs-12 header-notification-text d-block">
                                {notify.message}
                              </span>
                              <span className="text-muted fw-normal fs-11">{notify.relative_time ?? 'Just now'}</span>
                            </div>
                            <div>
                              {!notify.is_read ? (
                                <>
                                  <Link
                                    to="#"
                                    className={`min-w-fit-content text-muted me-1 dropdown-item-close1${markingNotificationId === notify.id ? ' disabled pe-none opacity-50' : ''}`}
                                    onClick={(event) => {
                                      event.preventDefault();
                                      if (markingNotificationId === notify.id) {
                                        return;
                                      }
                                      void markNotificationRead(notify.id);
                                    }}
                                  >
                                    {markingNotificationId === notify.id ? (
                                      <Spinner animation="border" size="sm" />
                                    ) : (
                                      <i className="ti ti-check fs-16"></i>
                                    )}
                                  </Link>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Fragment>
                  ))}
                </div>
                {!notificationLoadError && notifications.length > 0 && (
                  <div className="p-3 empty-header-item1 border-top">
                    <div className="text-center">
                      <Link to={`/pages/notification`} className="link-primary text-decoration-underline">View All</Link>
                    </div>
                  </div>
                )}
              </Dropdown.Menu>
            </Dropdown>
            {/* Fullscreen Button */}
            <li className="header-element header-fullscreen">
              <Link to="#" className="header-link" onClick={openFullscreen}>
                <i className={`bi bi-fullscreen${isFullScreen ? '-exit' : ''} header-link-icon`}></i>
              </Link>
            </li>
            {/* Profile Dropdown */}
            <Dropdown className="header-element" autoClose="outside">
              <Dropdown.Toggle as='a' className="header-link no-caret" variant="" id="mainHeaderProfile">
                <div className="d-flex align-items-center">
                  <div className="me-sm-2 me-0">
                    {caresBootstrap.user?.avatar_url ? (
                      <img src={caresBootstrap.user.avatar_url} alt="Profile" className="avatar avatar-sm avatar-rounded" />
                    ) : (
                      <span className="avatar avatar-sm avatar-rounded bg-primary-transparent text-primary fw-semibold">
                        {(caresBootstrap.user?.name ?? caresBootstrap.user?.email ?? 'U').slice(0, 1).toUpperCase()}
                      </span>
                    )}
                  </div>
                  <div className="d-xl-block d-none lh-1">
                    <span className="fw-medium lh-1">{caresBootstrap.user?.name ?? 'User'}</span>
                    {caresBootstrap.user?.email ? (
                      <span className="d-block fs-11 text-muted mt-1">{caresBootstrap.user.email}</span>
                    ) : null}
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="main-header-dropdown pt-0 overflow-hidden header-profile-dropdown" align='start'>
                <Dropdown.Item as={Link} className='d-flex align-items-center' to="/user-settings?tab=edit-profile"><i className="bi bi-person fs-18 me-2 op-7 lh-sm"></i>My Profile</Dropdown.Item>
                <Dropdown.Item className='d-flex align-items-center' href={`/common/firebase/signin/`}><i className="bi bi-box-arrow-right fs-18 me-2 op-7"></i>Log Out</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </ul>
        </div>
      </header>
    </Fragment>
  )
}


export default Header
